import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { OverviewOptionsAction, OverviewOptionsActionTypes } from './overview-options.actions';
import { OverviewOptions, OverviewOptionsState } from './overview-options.entity';

export const viewOptionsAdapter: EntityAdapter<OverviewOptions> = createEntityAdapter<OverviewOptions>({
    selectId: viewOptions => viewOptions.overview
});
export const emptyViewOptionsState: OverviewOptionsState = viewOptionsAdapter.getInitialState();

export function overviewOptionsReducer(state = emptyViewOptionsState, action: Action): OverviewOptionsState {
    const viewOptionsAction: OverviewOptionsAction = action as OverviewOptionsAction;
    switch (viewOptionsAction.type) {
        case OverviewOptionsActionTypes.SetSort:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, sort: viewOptionsAction.sort },
                state
            );
        case OverviewOptionsActionTypes.SetPagination:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, pagination: viewOptionsAction.pagination },
                state
            );
        case OverviewOptionsActionTypes.SetQueryParams:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, queryParams: viewOptionsAction.queryParams },
                state
            );
        case OverviewOptionsActionTypes.SetRecordSearch:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, recordSearch: viewOptionsAction.recordSearch },
                state
            );
        case OverviewOptionsActionTypes.SetBackToSearchLabel:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, backToSearchLabel: viewOptionsAction.label },
                state
            );
        case OverviewOptionsActionTypes.SetExpandedIds:
            return viewOptionsAdapter.upsertOne(
                { overview: viewOptionsAction.overview, expandedIds: viewOptionsAction.expandedIds },
                state
            );
        default:
            return state;
    }
}
